import { FC } from 'react';
import AppStoreLogo from './assets/logo-external/logo-app-store.svg';

const LogoAppStore: FC = () => {
  return <img src={AppStoreLogo} alt="App Store" style={{ maxWidth: '100%', maxHeight: '100%' }} />;
};

export default LogoAppStore;
